
import { ServiceLandingPage } from "@/components/service/ServiceLandingPage";

const TreeServicePage = () => {
  const features = [
    {
      title: "Tree Removal",
      description: "Safe removal of trees of any size, including stump removal"
    },
    {
      title: "Tree Trimming",
      description: "Expert pruning to improve tree health and appearance"
    },
    {
      title: "Emergency Services",
      description: "24/7 response for storm damage and hazardous situations"
    },
    {
      title: "Stump Grinding",
      description: "Complete removal of unsightly stumps from your property"
    },
    {
      title: "Disease Management",
      description: "Diagnosis and treatment of tree diseases and pest infestations"
    }
  ];

  const processSteps = [
    {
      title: "Free Consultation",
      description: "Schedule a visit for a certified arborist to assess your trees and provide recommendations"
    },
    {
      title: "Detailed Quote",
      description: "Receive a comprehensive estimate with all services clearly outlined"
    },
    {
      title: "Professional Service",
      description: "Experienced crews arrive with proper equipment to safely complete the job"
    },
    {
      title: "Complete Cleanup",
      description: "We leave your property clean and tidy with all debris properly disposed of"
    }
  ];

  const benefits = [
    {
      title: "ISA Certified Arborists",
      description: "Work with professionals who understand proper tree care practices"
    },
    {
      title: "24/7 Emergency Service",
      description: "Immediate response when storms or other emergencies threaten your property"
    },
    {
      title: "Fully Insured",
      description: "Complete peace of mind with comprehensive insurance coverage"
    },
    {
      title: "Local Expertise",
      description: "Knowledge of Oklahoma City's tree species and common issues"
    },
    {
      title: "Modern Equipment",
      description: "Access to specialized equipment for safe and efficient tree services"
    }
  ];

  return (
    <ServiceLandingPage
      title="Tree Service"
      metaDescription="Professional tree removal, trimming, and emergency services in Oklahoma City."
      introText="Expert tree care services for residential and commercial properties in Oklahoma City."
      features={features}
      processSteps={processSteps}
      benefits={benefits}
      ctaText="Ready to get your tree service needs handled professionally?"
      ctaButtonText="Get a Free Quote"
      contactText="Fill out the form below and we'll connect you with top tree service professionals in OKC."
    />
  );
};

export default TreeServicePage;
